import React, { Component } from 'react';

import DomainTypeSelector from '../../common/components/domain-type-selector';
import PropTypes from 'prop-types';
import { changeDomainType } from '../../common/actions/domain-selector-action-creators';
import { connect } from 'react-redux';
import { selectedDomainTypeSelector } from '../../reports/selectors/reports-selectors';

export class DomainTypeSelectorContainer extends Component{
    handleDomainTypeChange = ( domainType ) => {
        return this.props.changeDomainType( {
            domainType,
            namespace: this.props.namespace,
        } );
    };

    render(){
        const { selectedDomainType, namespace } = this.props;
        return (
            <DomainTypeSelector
                automationId={`domain-type-selector-${namespace}`}
                handleDomainTypeChange={this.handleDomainTypeChange}
                selectedDomainType={selectedDomainType}
            />
        );
    }
};

DomainTypeSelectorContainer.propTypes = {
    changeDomainType: PropTypes.func.isRequired,
    namespace: PropTypes.string.isRequired,
    selectedDomainType: PropTypes.string.isRequired
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        selectedDomainType: selectedDomainTypeSelector( state )
    };
};

export default connect( mapStateToProps, { changeDomainType } )( DomainTypeSelectorContainer );
